export default __webpack_public_path__ + "static/media/support-notes-main-iprofesional.3dbb7bd4.png";